import React, { useState, useRef, useEffect, MutableRefObject } from 'react'
import TagField from './TagField'
import plusIcon from '../../../../_metronic/images/fitler-plus-blue.svg'
import closeicon from '../../../../_metronic/images/closeSymbol.svg'
import { ADDPRODUCTSETUP, GET_CLIENT_ALLOWED_COMPONENTS } from '../../../../utils/GraphQLAPI'
import { useLazyQuery, useMutation } from '@apollo/client'
import { Spinner } from 'react-bootstrap'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import clsx from 'clsx'
import Utility from './Utility'
import uuid from 'react-uuid'
import { IUtility } from './InterfaceProductSetup'
import { alert } from '../../../../utils/helper'
import { DownloadTemplate } from '../../../sharedComponent/DownloadTemplate/DownloadTemplate'
import uploadIcon from '../../../../_metronic/images/upload.svg'
import UploadUtilityCSV from '../../../sharedComponent/UploadUtilityCSV'
import { GLOBAL_CONSTANTS } from '../../../../utils/GlobalConstants'
import DoNotEnrollList from '../DoNotEnroll/DoNotEnrollList'

const MySwal = withReactContent(Swal)
const generalTitle = 'General'
const utilityTitle = 'Utility'
const uploadTilte = 'Upload List'
const utilityMockData = {
  type: 'UTILITY',
  value: '',
  utilityDunsNumber: '',
  utilitySubmitDays: '',
  utilityPhoneNumber: '',
  utilityShortName: '',
  utilityName: '',
  uanValidation: '',
  regexValidation: '',
  regexValidationMessage: '',
  zipcodes: [],
}
const excludedEnumsWhenSolarProduct = ['CUSTOMER_TYPE', 'UNIT', 'BRAND_TYPE', 'CONTRACT_TYPE']

const excludedEnumsWhenNotSolarProduct = [
  'CUSTOMER_TYPE',
  'SOLAR_PRODUCT',
  'DEAL_SOURCE_TIER',
  'BENEFIT_PROGRAM',
]
const ProductSetup = ({
  editedData,
  setEditedData,
  getProductSetup,
  loading,
  data,
  featureFlags,
  solarProduct,
}: any) => {
  const [btnDisabled, setBtnDisabled] = useState(false)
  const [deletedId, setDeletedId] = useState<Array<string>>([])
  const [tab, setTab] = useState<string>(generalTitle)
  const [utilityData, setUtilityData] = useState<Array<IUtility>>([])
  const [errors, setErrors] = useState({})
  const [utilities, setUtilites] = useState<Array<string>>([])
  useEffect(() => {
    const utilityData = data?.getProductDetail
      ?.filter((item: any) => item.enum === 'UTILITY')[0]
      .names.map((utility: any) => {
        return {
          ...utility,
          enum: 'UTILITY',
        }
      })
    setUtilites(utilityData?.map((utility: IUtility) => utility.value.toLowerCase()))
    if (utilityData) {
      console.log('before modification', utilityData)
      setUtilityData(utilityData)
    }
  }, [data])

  //toaddproductsetup
  const [productSetupCrud] = useMutation(ADDPRODUCTSETUP, {
    onCompleted: () => {
      const options: any = {
        customClass: {
          popup: 'swal2-border-radius',
        },
        title: 'Product setup successful',
        icon: 'success',
        confirmButtonColor: '#3E97FF',
      }
      MySwal.fire(options)
    },
    onError: (err) => {
      MySwal.fire({
        icon: 'error',
        title: err.message,
      })
    },
  })
  const onSetupAdd = async () => {
    const productDetails = [...editedData, ...utilityData]
    //utility fields validation
    const errorUtilityData = utilityData.filter(
      (utility: IUtility) =>
        utility.value === '' ||
        utility.utilityDunsNumber === '' ||
        !Boolean(utility.utilityShortName) ||
        (Boolean(utility.utilityPhoneNumber) && utility.utilityPhoneNumber.length !== 10)
    )
    //if any error values to turn on that boolean and set the error state
    if (errorUtilityData.length > 0) {
      let errors = {}
      errorUtilityData.forEach((utility: IUtility) => {
        errors = {
          ...errors,
          [utility.id]: {
            utility: utility.value === '',
            dunsNumber: utility.utilityDunsNumber === '',
            invalidPhoneNumber:
              Boolean(utility.utilityPhoneNumber) && utility.utilityPhoneNumber.length !== 10,
            shortName: !Boolean(utility.utilityShortName),
          },
        }
      })
      setErrors(errors)
      tab === generalTitle && alert('Invalid Utility Data', 'warning')
    } else {
      const payload = {
        productDetails: productDetails.map((item: any) => {
          const data = {
            value: item.value,
            utilityDunsNumber: item.utilityDunsNumber,
            utilitySubmitDays: item.utilitySubmitDays,
            utilityShortName: item.utilityShortName,
            utilityName: item.utilityName,
            utilityPhoneNumber: item.utilityPhoneNumber,
            uanValidation: Boolean(item.uanValidation) ? Number(item.uanValidation) : null,
            regexValidation: item.regexValidation,
            regexValidationMessage: item.regexValidationMessage,
            zipcodes: item?.zipcodes,
            meterRegexValidation: item?.meterRegexValidation,
            meterRegexValidationMessage: item?.meterRegexValidationMessage,
            utilityState: item?.utilityState,
            notesMetadata: item?.notesMetadata
          }
          if (item.hasOwnProperty('readonly')) {
            return {
              id: item.id,
              type: item.enum,
              ...data,
            }
          } else {
            return {
              type: item.type,
              ...data,
            }
          }
        }),
        deleteProductDetail: deletedId,
      }

      await productSetupCrud({ variables: { addProductDetailInput: payload } })
      buttonRef.current.click()
      //calling get api again
      getProductSetup()
      handleModalClose()
    }
  }

  const addproductSetup = (
    value: string,
    id: string,
    type: string,
    add: boolean,
    newId: string
  ) => {
    //check for add or edit
    if (!add) {
      //for the existing data map through the value and change the edited value
      setEditedData((prevData: any) => {
        return prevData.map((item: any) => {
          if (item.id === id) {
            return { ...item, value, id: newId }
          }
          return item
        })
      })
    } else {
      //add the new data
      setEditedData((prevData: any) => [...prevData, { id, value, type }])
    }
  }

  const removeProductSetup = (id: string, added: boolean) => {
    //on deleting existing data we have to remove  it from our local stored data
    setEditedData((prevData: any) => {
      return prevData.filter((item: any) => {
        return item.id !== id
      })
    })
    if (!added) {
      //to add the id in array for api call
      setDeletedId((prev: any) => [...prev, id])
    }
  }

  //on discarding modal we have to remove our added and deleted data if any
  const handleModalClose = () => {
    setDeletedId([])
    setEditedData([])
    setTab(generalTitle)
  }

  const handleModalOpen = async () => {
    getProductSetup()
  }
  const handleTab = (targetTab: any) => {
    setTab(targetTab)
  }
  const buttonRef = useRef() as MutableRefObject<HTMLButtonElement>
  return (
    <>
      <button
        className='btn btn-primary fs-7'
        onClick={handleModalOpen}
        data-bs-toggle='modal'
        data-bs-target='#kt_modal_1'
      >
        <span>
          <i className='bi bi-gear-fill fs-6'></i>
        </span>
        Product Setup
      </button>

      <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
        <div className='modal-dialog  modal-dialog-scrollable modal-xl modal-fullscreen'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title fs-3 fw-bold'>Product Setup</h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => handleModalClose()}
              >
                <img src={closeicon} alt='close' />
              </div>
            </div>
            <div className='modal-body'>
              {loading ? (
                <div className='text-center'>
                  <Spinner animation='border' className='text-gray-600' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                  </Spinner>
                </div>
              ) : (
                data && (
                  <>
                    <ul
                      className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap'
                      role='tablist'
                    >
                      <li className='nav-item'>
                        <div
                          className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                            active: tab === generalTitle,
                          })}
                          onClick={() => handleTab(generalTitle)}
                          role='tab'
                        >
                          {generalTitle}
                        </div>
                      </li>
                      <li className='nav-item'>
                        <div
                          className={clsx(`nav-link cursor-pointer text-gray-600 fs-4`, {
                            active: tab === utilityTitle,
                          })}
                          onClick={() => handleTab(utilityTitle)}
                          role='tab'
                        >
                          {utilityTitle}
                        </div>
                      </li>
                      {(tab === utilityTitle || tab === uploadTilte) && (
                        <>
                          <li className='nav-item ms-auto'>
                            {featureFlags?.getClientFeatureFlags?.isUtilityMeterNumberRequired ? (
                              <DownloadTemplate
                                href={process.env.REACT_APP_UTILITY_WITH_METERID_TEMPLATE_DOWNLOAD}
                                text='Download Template'
                              />
                            ) : (
                              <DownloadTemplate
                                href={process.env.REACT_APP_UTILITY_TEMPLATE_DOWNLOAD}
                                text='Download Template'
                              />
                            )}
                          </li>
                          <li>
                            <button
                              className='btn btn-light-primary btn-active-light-primary ms-4'
                              onClick={(e: any) => handleTab(uploadTilte)}
                              role='tab'
                            >
                              <img src={uploadIcon} alt='' className='svg-icon svg-icon-1' />
                              <span className='fw-bold fs-base'>{uploadTilte}</span>
                            </button>
                          </li>
                        </>
                      )}
                    </ul>

                    <div className='tab-content pt-3 min-h-500px'>
                      <div className={clsx('tab-pane', { active: tab === generalTitle })}>
                        {data?.getProductDetail
                          ?.filter((item: any) =>
                            solarProduct
                              ? item.enum === 'CUSTOMER_TYPE'
                              : item.enum === 'COMMODITY' || item.enum === 'CUSTOMER_TYPE'
                          )
                          .map((item: any) => (
                            <TagField
                              key={item.type}
                              label={item.type}
                              enumType={item.enum}
                              onAdd={addproductSetup}
                              onRemove={removeProductSetup}
                              name={item.type}
                              initialValue={item.names}
                              className='no-focus'
                              isEditable={false}
                            />
                          ))}

                        {data?.getProductDetail
                          ?.filter(
                            (item: any) =>
                              item.enum !== 'UTILITY' &&
                              item.enum !== 'COMMODITY' &&
                              ((solarProduct &&
                                !excludedEnumsWhenSolarProduct.includes(item.enum)) ||
                                (!solarProduct &&
                                  !excludedEnumsWhenNotSolarProduct.includes(item.enum)))
                          )
                          .map((item: any) => (
                            <TagField
                              key={item.type}
                              label={item.type}
                              enumType={item.enum}
                              onAdd={addproductSetup}
                              onRemove={removeProductSetup}
                              name={item.type}
                              initialValue={item.names}
                            />
                          ))}
                      </div>
                      <div className={clsx('tab-pane', { active: tab === utilityTitle })}>
                        {utilityData?.map((utility: any, index: number) => (
                          <Utility
                            {...utility}
                            setUtilityData={setUtilityData}
                            deletedId={deletedId}
                            setDeletedId={setDeletedId}
                            utilities={utilities}
                            errors={errors}
                            setErrors={setErrors}
                            original={utilityData}
                            featureFlags={featureFlags}


                          />
                        ))}

                        <button
                          className='btn btn-active-light-primary btn-light-primary fs-6 px-5 py-3 mt-4'
                          onClick={() =>
                            setUtilityData((prev: any) => [
                              ...prev,
                              { ...utilityMockData, id: uuid() },
                            ])
                          }
                        >
                          <div className='d-flex '>
                            <img src={plusIcon} alt='' className='svg-icon svg-icon-1 me-0' />
                            <div className='fs-5 w-100px'>Add Utility</div>
                          </div>
                        </button>
                      </div>
                      <div className={clsx('tab-pane', { active: tab === uploadTilte })}>
                        <UploadUtilityCSV
                          fileUploadErr={false}
                          setFileUploadErr={undefined}
                          arrayHelpers={undefined}
                          setUtilityData={setUtilityData}
                          originalutilityData={utilityData}
                          setBtnDisabled={setBtnDisabled}
                          btnDisabled={btnDisabled}
                          featureFlags={featureFlags?.getClientFeatureFlags?.isUtilityMeterNumberRequired}

                        />
                      </div>
                    </div>
                  </>
                )
              )}
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-light'
                data-bs-dismiss='modal'
                onClick={() => handleModalClose()}
                ref={buttonRef}
              >
                Discard
              </button>
              <button type='button' disabled={btnDisabled} onClick={() => onSetupAdd()} className='btn btn-primary'>
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProductSetup
